export default __webpack_public_path__ + "static/media/refresh-icon.0a455c7c.svg";